import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Field} from "../form/Field";
import {PageContent} from "../Layout";
import {Input} from "../form/fields/Input";
import {Button, Col, Row} from "reactstrap";
import {api} from "../../api";
import {Textarea} from "../form/fields/Textarea";
import {IWindow} from "../../index";
import DropZone, {DropZoneStore} from "../../stores/DropZoneStore";

const IWindow: IWindow = (window as IWindow);

export class ProfileFormData {
    @observable id = IWindow.initialState.user.id;
    @observable name = '';
    @observable username = '';
    @observable email = '';
    @observable phone_number = '';
    @observable address = '';
    @observable other_details = '';
    @observable upload_id = null;
    @observable profile_image = {};
    @observable profile_saved = '';

    @observable current_password = '';
    @observable password = '';
    @observable password_confirmation = '';
    @observable password_saved = '';
}

export class ProfileForm extends CrudForm {
    modelName = 'Profile';
    dropZoneStore = new DropZoneStore();
	
	 
	
    djsConfig = {
        maxFilesize: 1,
        acceptedFiles: "image/jpeg,image/png,image/gif",
        maxSize: 1024,
        paramName: "file_upload",
        params: {
            file_field: 'profile_image',
        }
    };

    componentConfig = {
        postUrl: 'upload',
    };

    eventHandlers = {

        error: (file: any, response: any) => {
            //const message = response.message ? 'error in upload' : response;
            //this.props.rootStore.messageStore.showErrorMessage(message);
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
        },
        success: (file: any, response: any) => {
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
            this.formStore.setValue('upload_id', response.upload_id);
            this.formStore.setValue('profile_image', response);
            // update user profile to link image to user
            //this.postData(this.formStore.data);
        },
    };

    getData = async () => {
        await api.profile.getDetailAction().then((data: any) => {
            this.formStore.setData(data.data);
            this.entity = data.data;
        });
        this.isLoading = false;
    };
	
	 

    postData = (data: any) => {
        return api.profile.postUpdateAction(data).then((response: any) => {
            this.formStore.setValue('profile_image', response.data.profile_image);
            this.formStore.setValue('profile_saved', response.data);
        });
    };

    onClickButton (event:any) {
        event.preventDefault();
    };

    renderFields() {
        return (
            <>
                {
                    this.formStore.getValue('profile_saved')?
                        <Row className="form-row">
                            <Col md={12}>
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    Profile updated successfully!
                                </div>
                            </Col>
                        </Row> : ''
                }

                <Row className="form-row">
                    <Col md={3}>

                        <DropZone
                            store={this.dropZoneStore}
                            componentConfig={this.componentConfig}
                            djsConfig={this.djsConfig}
                            eventHandlers={this.eventHandlers}
                        >
                            <Button className="image-uploader" onClick={this.onClickButton}>
                                {
                                    this.formStore.getValue('profile_image') ?
                                        <img src={this.formStore.data.profile_image.urls.thumb}
                                             style={{width: 120, height: 120}}/> :
                                        <img src="https://fakeimg.pl/120/120"/>
                                }
                            </Button>
                            <div
                                className="form-progress-bar"
                                style={{width: `${this.dropZoneStore.progress}%`}}
                            />
                        </DropZone>

                    </Col>

                    <Col md={9}>
                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    label="Full Name"
                                    name="name"
                                    component={Input}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>

                            <Col md={6}>
                                <Field
                                    label="username"
                                    name="username"
                                    component={Input}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    label="Email"
                                    name="email"
                                    type="email"
                                    component={Input}
                                    store={this.formStore}
                                />
                            </Col>

                            <Col md={6}>
                                <Field
                                    label="Phone number"
                                    name="phone_number"
                                    component={Input}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    label="Address"
                                    name="address"
                                    component={Input}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>

                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <Field
                                    label="Other Details"
                                    name="other_details"
                                    component={Textarea}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </>
        );
    }
}

export class ChangePasswordForm extends CrudForm {
    modelName = 'Profile';

    postData = (data: any) => {
        return api.user.postChangePasswordAction(data).then((response: any) => {
            this.formStore.setValue('password_saved', response.message);
        });
    };

    renderFields() {
        return (
            <>
				<Row className="form-row">
                    <Col md={12}>&nbsp;</Col>
				</Row>	
				
				<Row className="form-row">
                    <Col md={12}>&nbsp;</Col>
				</Row>	
			
                <Row className="form-row">
                    <Col md={3}>

                    </Col>

                    <Col md={9}>
                        {
                            this.formStore.getValue('password_saved')?
                                <Row className="form-row">
								
                                    <Col md={12}>
                                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            Password updated successfully!
                                        </div>
                                    </Col>
                                </Row> : ''
                        }

                        <Row className="form-row">
                            <Col md={4}>
                                <Field
                                    label="Old Password"
                                    name="current_password"
                                    component={Input}
                                    type={"password"}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>

                            <Col md={4}>
                                <Field
                                    label="New Password"
                                    name="password"
                                    component={Input}
                                    type={"password"}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>

                            <Col md={4}>
                                <Field
                                    label="Confirm Password"
                                    name="password_confirmation"
                                    component={Input}
                                    type={"password"}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
				
            </>
        );
    }
}

export class ProfilePage extends React.Component {
    modelName = 'Profile';

    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <>
                <PageContent>
                    <ProfileForm/>
                    <ChangePasswordForm/>
                </PageContent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ProfilePage.tsx